import React from "react";

export default function LoadingOverlay() {
  return (
    <div className="loader-container">
      <div className="loader"></div>
    </div>
  );
}
